import React from "react";
import ContactList from "./ContactList";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";
import ContactListControls from "./ContactListControls";
import IContact from "../../models/IContact";
import snackbarService from "../../services/ui-messaging/SnackbarService";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import { connect } from "react-redux";
import ICompany from "../../models/ICompany";
import { selectCompany } from "../../store/context/selectors";
import Services from "../../services/Services";

export interface IContactListWithDataProps {
  token: string;
  company?: ICompany;
}

const ContactListWithData = (props: IContactListWithDataProps) => {
  const { token, company } = props;

  const [contacts, setContacts] = React.useState<Array<IContact>>([]);
  const [showInactive, setShowInactive] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [quietReload, setQuietReload] = React.useState(false);
  const [stamp, setStamp] = React.useState(new Date());

  React.useEffect(() => {
    const getContacts = async () => {
      const contactRepo = await new Services().ContactRepository();
      if (!company) {
        return;
      }

      try {
        setIsLoading(true);
        const resp = await contactRepo.get(token, company.ID, showInactive);
        setContacts(resp);
      } catch (err) {
        snackbarService.error(err);
      }

      setIsLoading(false);
      setQuietReload(false);
    };

    getContacts();
  }, [showInactive, company, stamp]);

  const handleRefresh = () => {
    setQuietReload(true);
    setStamp(new Date());
  };

  return (
    <>
      <ContactListControls company={company!} showInactive={showInactive} onShowInactiveChange={setShowInactive} />
      <WithLoadingSpinners message="Gathering data" isLoading={!quietReload && isLoading}>
        <ContactList contacts={contacts} onRequestRefresh={() => handleRefresh()} type={company!.Type} />
      </WithLoadingSpinners>
    </>
  );
};

export default connect((state: IApplicationState) => {
  return {
    ...selectAuth(state),
    company: selectCompany(state),
  };
})(ContactListWithData);
